export default __webpack_public_path__ + "static/media/ville.28b34c68.svg";